module.exports = __webpack_public_path__ + "media/images/icon_remarks01_12-14-cf1452327bf0fb344cc34167a2b6219e.png";